import ExpertProfileVisibilityModalModule from './expert-profile-visibility-modal.module'

export default ExpertProfileVisibilityModalModule
